import {Project} from './project';
import {ForecastTimeSeriesQuery} from './series';

export function mockProjectData(project: Project): Project {
  project.sites?.forEach((site) => {
    Object.values(site.forecastTimeSeries).forEach((seriesList) => {
      seriesList.forEach((series) => {
        if (series.source === 'hydroforecast-short-term') {
          series.sourceMetadata = mockProjectsResponse['data']['sites'][0].forecastTimeSeries[
            'flow-short-term'
          ][0].sourceMetadata as ForecastTimeSeriesQuery['sourceMetadata'];
        }
      });
    });
  });
  return project;
}

const mockProjectsResponse = {
  data: {
    defaultDateRange: ['2019-08-01T00:00+0000', '2021-12-21T00:00+0000'],
    id: 'test-flow-sites',
    // "keyQueries" removed
    name: 'Test Flow Project',
    sites: [
      {
        featureIds: {
          drainageAreaFeatureId: 1,
          forecastPointFeatureId: 2,
        },
        forecastTimeSeries: {
          'flow-short-term': [
            {
              columns: ['discharge_mean', 'discharge_q0.5'],
              siteId: 'flow-1',
              source: 'hydroforecast-short-term',
              // Modified //////////////////////////////////////////////////////
              sourceMetadata: {
                modelGeneration: 'short-term-3', // use this for the pill / st3 callout
                // open question: should traces exist if st2?
                // open question: how will these be named?
                traces: ['blend', 'hrrr', 'gefs'], // this refers to what single source traces are available, what we query for
              },
            },
          ],
          // weather sources also included here, unchanging
        },
        //////////////////////////////////////////////////////////////////
        id: 'flow-1',
        localTimeZone: 'UTC',
        name: 'First in Flow',
        observationTimeSeries: [
          // lots of observations of weather stuff here
        ],
        seriesTypes: ['flow-short-term', 'weather-short-term', 'surface-observations'],
        siteType: 'basin',
      },
    ],
  },
};
